import { withButtonPortal } from '../hoc/withPortal';
import Button from './Button';

const StatusBarButton = ({ statusSlot = 5, ...rest}) => {
  return withButtonPortal(<Button {...rest} />, statusSlot);
};

export default StatusBarButton;
